import { useState } from 'react'
import { FaPencilAlt, FaTrashAlt } from 'react-icons/fa'
import { FiUser, FiCalendar } from 'react-icons/fi'

import Modal from '../../../../shared/modal/Modal'
import api from '../../../../utils/api'
import ConfirmDeleteModal from '../../../../shared/components/ConfirmDeleteModal/ConfirmDeleteModal'
import { ReactComponent as GeneratorIcon } from '../../../../shared/img/icon/generator.svg'

import EditServiceOrder from '../../ServiceOrder/EditServiceOrder'

/* Hooks */
import useFlashMessage from '../../../../hooks/useFlashMessage'
import useMyPermission from '../../../../hooks/useMyPermission'

const STATUS_LABEL = {
    aberta: { label: 'Aberta', className: 'so-status-aberta' },
    em_andamento: { label: 'Em andamento', className: 'so-status-em_andamento' },
}

const formatDate = (value) => {
    if (!value) return ''
    const [year, month, day] = value.split('-')
    return day && month && year ? `${day}/${month}/${year}` : value
}

const getShortName = (fullName) => {
    if (!fullName) return ''
    const parts = fullName.trim().split(/\s+/)
    return parts.length > 1 ? `${parts[0]} ${parts[parts.length - 1]}` : parts[0]
}

// Paleta categórica (8 matizes, ordem fixa validada para distinção entre cores)
const TECHNICIAN_COLORS = [
    { bg: '#2a78d6', text: '#ffffff' }, // blue
    { bg: '#1baf7a', text: '#ffffff' }, // aqua
    { bg: '#eda100', text: '#1f2937' }, // yellow
    { bg: '#008300', text: '#ffffff' }, // green
    { bg: '#4a3aa7', text: '#ffffff' }, // violet
    { bg: '#e34948', text: '#ffffff' }, // red
    { bg: '#e87ba4', text: '#ffffff' }, // magenta
    { bg: '#eb6834', text: '#ffffff' }, // orange
]

const getTechnicianColor = (key) => {
    const str = String(key || '')
    let hash = 0
    for (let i = 0; i < str.length; i++) {
        hash = (hash * 31 + str.charCodeAt(i)) >>> 0
    }
    return TECHNICIAN_COLORS[hash % TECHNICIAN_COLORS.length]
}

function ListServiceOrderOpenRow({ dataArray, myPermission, handleOnSuccess }) {

    const [token] = useState(localStorage.getItem('token') || '')
    const { setFlashMessage } = useFlashMessage()

    /* ------------------- Modal useState ----------------------*/

    const [modalEditServiceOrder, setModalEditServiceOrder] = useState(false)
    const [serviceOrderId, setServiceOrderId] = useState("")
    const [modalDeleteItem, setModalDeleteItem] = useState(false)
    const [serviceOrderCode, setServiceOrderCode] = useState("")

    /* permission */
    const { checkPermission } = useMyPermission()
    const myPermissionEdit = checkPermission(myPermission, "serviceOrder_Edit")
    const myPermissionDelete = checkPermission(myPermission, "serviceOrder_Delete")

    async function deleteServiceOrder(id) {
        let msgType = 'success'
        const data = await api.delete(`/serviceOrder/delete/${id}`, {
            headers: {
                Authorization: `Bearer ${JSON.parse(token)}`,
            },
        }).then((response) => {
            if (response) {
                handleOnSuccess()
                setModalDeleteItem(false)
            }

            return response.data
        }).catch((err) => {

            msgType = 'error'
            return err.response.data
        })

        setFlashMessage(data.message, msgType)
    }

    return (
        <div>
            {dataArray && dataArray.map((item) => (
                <div key={item._id} className="pg-item">
                    <div className="pg-item-main">
                        <div className="pg-item-header">
                            <span className="pg-item-name">{item.code || '—'}</span>
                            {item.status?.value && (
                                <span className={`so-status-badge ${STATUS_LABEL[item.status.value]?.className || ''}`}>
                                    {STATUS_LABEL[item.status.value]?.label || item.status.label}
                                </span>
                            )}
                        </div>

                        <div className="so-item-desc">{item.name}</div>

                        <div className="so-item-meta">
                            <span className="so-item-meta-item">
                                <FiUser size={11} />
                                {item.client?.label || item.client?.name || '—'}
                            </span>
                            {item.generator?.label && (
                                <>
                                    <span className="so-item-meta-sep">·</span>
                                    <span className="so-item-meta-item">
                                        <GeneratorIcon className="so-item-meta-icon" />
                                        {item.generator.label}
                                    </span>
                                </>
                            )}
                            {item.scheduledDate && (
                                <>
                                    <span className="so-item-meta-sep">·</span>
                                    <span className="so-item-meta-item">
                                        <FiCalendar size={11} />
                                        Agendado: {formatDate(item.scheduledDate)} das {item.scheduledStartTime} às {item.scheduledEndTime}
                                    </span>
                                </>
                            )}
                            {item.technicians?.length > 0 && (
                                <>
                                    <span className="so-item-meta-sep">·</span>
                                    <span className="so-technician-badges">
                                        {item.technicians.map((t) => {
                                            const color = getTechnicianColor(t._id || t.value || t.name)
                                            return (
                                                <span
                                                    key={t._id || t.value || t.name}
                                                    className="so-technician-badge"
                                                    style={{ backgroundColor: color.bg, color: color.text }}
                                                >
                                                    {getShortName(t.name || t.label)}
                                                </span>
                                            )
                                        })}
                                    </span>
                                </>
                            )}
                        </div>
                    </div>

                    <div className='shd-row-box-item-action'>
                        {myPermissionEdit &&
                            <FaPencilAlt
                                className='shd-icon-row-edit'
                                title='Editar'
                                onClick={() => { setServiceOrderId(item._id); setModalEditServiceOrder(true) }}
                            />
                        }
                        {myPermissionDelete &&
                            <FaTrashAlt
                                className='shd-icon-row-trash'
                                title='Apagar'
                                onClick={() => { setModalDeleteItem(true); setServiceOrderId(item._id); setServiceOrderCode(item.code || item.name) }}
                            />
                        }
                    </div>
                </div>
            ))}

            <Modal
                modalStatus={modalEditServiceOrder}
                changeStatus={setModalEditServiceOrder}
                w={82}
                content={
                    <EditServiceOrder id={serviceOrderId} handleOnSuccess={() => { setModalEditServiceOrder(false); handleOnSuccess() }} btCancelAction={() => setModalEditServiceOrder(false)} />
                }
            />

            <ConfirmDeleteModal
                modalStatus={modalDeleteItem}
                changeStatus={setModalDeleteItem}
                onConfirm={() => deleteServiceOrder(serviceOrderId)}
                message="Deseja realmente excluir essa ordem de serviço?"
                itemName={serviceOrderCode}
            />
        </div>
    )
}

export default ListServiceOrderOpenRow
